import { FC, useState } from 'react'
import { Country } from '../../types'
import { DraftScoreGridsTable } from './DraftScoreGridsTable'
import { useTranslation, Trans } from 'react-i18next'
import PerText from '../../components/custom_components/Text'
import PerSpacer from '../../components/custom_components/Spacer'
import { PerCollapse } from '../../components/custom_components/Collapse'
import BackgroundBox from '../../components/custom_components/BackgroundBox'

interface ScoreGridsPageContentProps {
  companyId: string
  country: Country
}

export const ScoreGridsPageContent: FC<ScoreGridsPageContentProps> = ({ companyId, country }) => {
  const [expanded, setExpanded] = useState<boolean>(false)

  return (
    <>
      <ScoreGridDisclaimerCollapse setExpanded={setExpanded} />

      <PerSpacer mb="xs" />

      <DraftScoreGridsTable expanded={expanded} companyId={companyId} country={country} />
    </>
  )
}

export const ScoreGridDisclaimerCollapse: FC<{
  setExpanded: (collapsed: boolean) => void
}> = ({ setExpanded }) => {
  const [collapsed, setCollapsed] = useState<boolean>(false)
  const [t] = useTranslation()

  return (
    <BackgroundBox r noShadow>
      <PerCollapse
        defaultActiveKey={collapsed ? -1 : 0}
        onChange={() => {
          if (collapsed) {
            setCollapsed(false)
            setExpanded(false)
          } else {
            setCollapsed(true)
            setTimeout(() => {
              setExpanded(true)
            }, 200)
          }
        }}
        panels={[
          {
            headingElement: <PerText appearance="tile-heading">{t('draftScoreGrid.table.descriptionHeading')}</PerText>,
            content: (
              <div style={{ maxHeight: 170, overflow: 'auto' }}>
                <PerText fontSize="s">
                  <PerSpacer mb="xs">
                    <PerText>{t('draftScoreGrid.table.description0')}</PerText>
                  </PerSpacer>
                  <PerSpacer mb="xs">
                    <PerText fontWeight="bold">{t('draftScoreGrid.table.description1')}</PerText>
                    <Trans i18nKey="draftScoreGrid.table.description1_1" components={[<b></b>]} />
                    <ol>
                      <li>
                        <Trans i18nKey="draftScoreGrid.table.description1_1_item1" components={[<b></b>]} />
                      </li>
                      <li>
                        <Trans i18nKey="draftScoreGrid.table.description1_1_item2" components={[<b></b>]} />
                      </li>
                      <li>
                        <Trans i18nKey="draftScoreGrid.table.description1_1_item3" components={[<b></b>]} />
                      </li>
                      <li>
                        <Trans i18nKey="draftScoreGrid.table.description1_1_item4" components={[<b></b>]} />
                      </li>
                      <li>
                        <Trans i18nKey="draftScoreGrid.table.description1_1_item5" components={[<b></b>]} />
                      </li>
                    </ol>
                    <Trans i18nKey="draftScoreGrid.table.description1_1_footer" components={[<b></b>]} />
                  </PerSpacer>
                  <PerSpacer mb="xs">
                    <PerText fontWeight="bold">{t('draftScoreGrid.table.description2')}</PerText>
                    <PerText>{t('draftScoreGrid.table.description2_1')}</PerText>
                  </PerSpacer>
                  <PerSpacer>
                    <PerText fontWeight="bold">{t('draftScoreGrid.table.description3')}</PerText>
                    <Trans i18nKey="draftScoreGrid.table.description3_1" components={[<b></b>]} />
                  </PerSpacer>
                </PerText>
              </div>
            ),
          },
        ]}
      />
    </BackgroundBox>
  )
}
